import React, { useEffect, useState } from "react";
import Page from "~/components/Page";
import AdvancedSearchMenu from "~/components/AdvancedSearchMenu";
import SearchBarContext from "~/SearchBarContext";
import SearchQuery from "~/searchQuery";
import BackToSearchResultsButton from "~/components/BackToSearchResultsButton";
import { useQueryURLSearchParams } from "~/util/hooks";

const HomePage = () => {
  const [searchQuery, setSearchQuery] = useState(new SearchQuery());

  // Get query from the url
  const pageQuery = useQueryURLSearchParams();
  useEffect(() => {
    const newQuery = SearchQuery.fromQueryString(pageQuery);
    if (newQuery.isValid()) {
      setSearchQuery(newQuery);
    }
  }, [pageQuery.toString()]);

  return (
    <SearchBarContext.Provider value={{ searchQuery, setSearchQuery }}>
      <Page title="Advanced search">
        <div className="p-4">
          <div className="mb-6 px-8">
            <BackToSearchResultsButton />
          </div>
          <div className="w-full py-4">
            <div className="flex">
              <div className="w-full lg:w-3/4">
                <AdvancedSearchMenu />
              </div>
            </div>
          </div>
        </div>
      </Page>
    </SearchBarContext.Provider>
  );
};

export default HomePage;
